import React, { useEffect, useState } from 'react';
import './Cashmanagment.css';
import Card32 from '../components/Card32';
import Card33 from '../components/Card33';
import Card34 from '../components/Card34';
import Card37 from '../components/Card37';
import Card from '../components/Card';
import Card1 from '../components/Card1';
import Card41 from '../components/Card41';
import Card42 from '../components/Card42';
import Card3 from '../components/Card3';
import Card4 from '../components/Card4';
import Graph5 from '../components/Graph5';
import Graph6 from '../components/Graph6';
import Graph7 from '../components/Graph7';
import Graph8 from '../components/Graph8';
import Graph9 from '../components/Graph9';
import Fichearticle from './Fichearticle';

const API = window.location.hostname === 'localhost'
  ? 'http://localhost:5000/api'
  : 'https://myssa1.osc-fr1.scalingo.io/api';

/* ─── Couleurs des boutons nav ─── */
const NAV_CONFIG = [
  { key: 'stock',   label: 'Stock projeté', dot: '#185FA5', activeClass: 'active-stock'   },
  { key: 'cashin',  label: 'Cash in',       dot: '#1D9E75', activeClass: 'active-cashin'  },
  { key: 'cashout', label: 'Cash out',      dot: '#D85A30', activeClass: 'active-cashout' },
];

/* ─── Clés réelles en base ─── */
const MONTH_KEYS = ['M','M+1','M+2','M+3','M+4','M+5','M+6','M+7','M+8','M+9','M+10','M+11'];

/* ─── Génère le mapping clé → label lisible (ex: "Juin 2026") ─── */
const getMonthLabels = () => {
  const now = new Date();
  const labels = {};
  MONTH_KEYS.forEach((key, i) => {
    const d = new Date(now.getFullYear(), now.getMonth() + i, 1);
    const raw = d.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' });
    labels[key] = raw.charAt(0).toUpperCase() + raw.slice(1);
  });
  return labels;
};

const Cashmanagment = () => {
  const [tauxData, setTauxData] = useState(null);
  const [showGraph7, setShowGraph7] = useState(false);
  const [showGraph8, setShowGraph8] = useState(false);
  const [showGraph9, setShowGraph9] = useState(false);
  const [filterColumn, setFilterColumn] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [clientSelectionne, setClientSelectionne] = useState(null);
  const [commandesClient, setCommandesClient] = useState([]);
  const [modalItem, setModalItem] = useState(null);
  const [fournisseurSelectionne, setFournisseurSelectionne] = useState(null);
  const [commandesFournisseur, setCommandesFournisseur] = useState([]);

  useEffect(() => {
    document.title = 'MYSSA – Cash managment';
  }, []);

  const colonnesAffichees = ['Num BL', 'Num Facture', 'Date échéance', 'Retard paiement', 'Reste à payer'];

  /* ── Détermine la vue active ── */
  const activeNav = showGraph7 ? 'stock' : showGraph8 ? 'cashin' : showGraph9 ? 'cashout' : null;

  /* ── Handler clic barre Graph7 → filtre tableau ── */
  const handleBarClick = (monthKey) => {
    setFilterColumn(prev => prev === monthKey ? null : monthKey);
  };

  /* ── Handlers navigation ── */
  const handleCard32Click = () => {
    fetch(`${API}/evolution_stock`)
      .then((res) => {
        if (!res.ok) throw new Error('Erreur chargement PG');
        return res.json();
      })
      .then((data) => {
        const dataTriee = data.sort((a, b) => parseFloat(b.Indice) - parseFloat(a.Indice));
        setTauxData(dataTriee);
        setShowGraph7(true);
        setShowGraph8(false);
        setShowGraph9(false);
        setFilterColumn(null);
      })
      .catch((err) => {
        console.error('Erreur fetch:', err);
        setTauxData(null);
        setShowGraph7(false);
      });
  };

  const handleCard33Click = () => {
    setShowGraph8(true);
    setShowGraph7(false);
    setShowGraph9(false);
    setClientSelectionne(null);
    setCommandesClient([]);

    fetch('/montant_echue_client.json')
      .then((res) => res.json())
      .then((data) => {
        const ligneTotal = data.find((ligne) => ligne.Client?.toUpperCase() === 'TOTAL');
        const donneesFiltrees = data
          .filter((ligne) => ligne.Client?.toUpperCase() !== 'TOTAL')
          .sort((a, b) => parseFloat(b['Montant échue']) - parseFloat(a['Montant échue']));
        if (ligneTotal) donneesFiltrees.push(ligneTotal);
        setTableData(donneesFiltrees);
      })
      .catch((err) => console.error('Erreur chargement JSON :', err));
  };

  const handleCard34Click = () => {
    setShowGraph9(true);
    setShowGraph7(false);
    setShowGraph8(false);
    setClientSelectionne(null);
    setCommandesClient([]);

    fetch('/montant_echue_frn.json')
      .then((res) => res.json())
      .then((data) => {
        const ligneTotal = data.find((ligne) => ligne.Fournisseur?.toUpperCase() === 'TOTAL');
        const donneesFiltrees = data
          .filter((ligne) => ligne.Fournisseur?.toUpperCase() !== 'TOTAL')
          .sort((a, b) => parseFloat(b['Montant échue']) - parseFloat(a['Montant échue']));
        if (ligneTotal) donneesFiltrees.push(ligneTotal);
        setTableData(donneesFiltrees);
      })
      .catch((err) => console.error('Erreur chargement montant_echue_frn.json :', err));
  };

  const NAV_HANDLERS = {
    stock:   handleCard32Click,
    cashin:  handleCard33Click,
    cashout: handleCard34Click,
  };

  /* ── Handler client ── */
  const handleClientClick = (client) => {
    setClientSelectionne(client);
    fetch('/base_de_donnee_cmde_client.json')
      .then((res) => res.json())
      .then((data) => {
        const commandesFiltres = data.filter((ligne) => ligne.Client === client);
        setCommandesClient(commandesFiltres);
      })
      .catch((err) => console.error('Erreur chargement base_de_donnee_cmde_client.json:', err));
  };

  /* ── Handler fournisseur ── */
  const handleFournisseurClick = (fournisseur) => {
    setFournisseurSelectionne(fournisseur);
    fetch('/base_de_donnee_cmde_frn.json')
      .then((res) => res.json())
      .then((data) => {
        const commandesFiltres = data
          .filter((ligne) => ligne.Fournisseur === fournisseur)
          .sort((a, b) => parseFloat(b["Montant"]) - parseFloat(a["Montant"]));
        setCommandesFournisseur(commandesFiltres);
      })
      .catch((err) => console.error('Erreur chargement base_de_donnee_cmde_frn.json:', err));
  };

  /* ── Tableau commandes client échues ── */
  const renderCommandesClientTable = () => {
    if (!clientSelectionne) return null;
    const commandesFiltreesEchue = commandesClient.filter(
      (ligne) => ligne['Statut paiement'] === 'Echue'
    );

    if (commandesFiltreesEchue.length === 0)
      return (
        <div className="detail_cmde_echue">
          <p style={{ padding: '16px', color: '#6b7280' }}>Aucune commande échue pour ce client.</p>
        </div>
      );

    return (
      <div className="detail_cmde_echue">
        <table>
          <thead>
            <tr>
              {colonnesAffichees.map((col) => (
                <th key={col}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {commandesFiltreesEchue.map((row, idx) => (
              <tr key={idx}>
                {colonnesAffichees.map((col, i) => (
                  <td key={i}>
                    {typeof row[col] === 'number' ? row[col].toLocaleString('fr-FR') : row[col]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  /* ── Tableau taux de couverture ── */
  const renderTauxTable = () => {
    if (!tauxData || tauxData.length === 0) return null;

    const colonnesFixes = ['Item', 'Déscription'];
    const monthLabels = getMonthLabels();

    let dataAffichee = tauxData;
    if (filterColumn && MONTH_KEYS.includes(filterColumn)) {
      dataAffichee = [...tauxData]
        .sort((a, b) => parseFloat(b[filterColumn]) - parseFloat(a[filterColumn]))
        .slice(0, 10);
    }

    return (
      <div className="taux-container">
        <table>
          <thead>
            <tr>
              {colonnesFixes.map((col, i) => (
                <th
                  key={col}
                  style={{
                    position: 'sticky',
                    left: i === 0 ? 0 : 150,
                    zIndex: 2,
                    minWidth: i === 0 ? '150px' : '260px',
                  }}
                >
                  {col}
                </th>
              ))}
              {MONTH_KEYS.map((key) => (
                <th
                  key={key}
                  onClick={() => handleBarClick(key)}
                  title="Cliquez pour afficher les 10 plus grandes valeurs"
                  style={{
                    backgroundColor: filterColumn === key ? '#dbeafe' : undefined,
                    color:           filterColumn === key ? '#185FA5' : undefined,
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {monthLabels[key]}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {dataAffichee.map((row, idx) => (
              <tr key={idx}>
                {colonnesFixes.map((col, i) => (
                  <td
                    key={col}
                    className={col === 'Item' ? 'item-link' : ''}
                    onClick={col === 'Item' ? () => setModalItem(row['Item']) : undefined}
                    style={{
                      position: 'sticky',
                      left: i === 0 ? 0 : 150,
                      backgroundColor: 'white',
                      zIndex: 1,
                      minWidth: i === 0 ? '150px' : '260px',
                    }}
                  >
                    {row[col]}
                  </td>
                ))}
                {MONTH_KEYS.map((key) => (
                  <td key={key} style={{ minWidth: 80 }}>
                    {Math.round(parseFloat(row[key]))}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className="cadre">

      {/* ══════════════════════════════════════
          MODAL FICHEARTICLE
      ══════════════════════════════════════ */}
      {modalItem && (
        <div className="modal-overlay" onClick={() => setModalItem(null)}>
          <div className="modal-inner" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={() => setModalItem(null)}>
              ✕ Fermer
            </button>
            <Fichearticle itemPrefill={modalItem} />
          </div>
        </div>
      )}

      {/* ══════════════════════════════════════
          BOUTONS NAVIGATION
      ══════════════════════════════════════ */}
      <div
        className="nav-buttons-wrapper"
        style={{ position: 'absolute', top: '50px', left: '500px' }}
      >
        {NAV_CONFIG.map(({ key, label, dot, activeClass }) => (
          <button
            key={key}
            className={`nav-btn${activeNav === key ? ` ${activeClass}` : ''}`}
            onClick={NAV_HANDLERS[key]}
          >
            <span className="btn-dot" style={{ background: dot }} />
            {label}
          </button>
        ))}
      </div>

      {/* ══════════════════════════════════════
          VUE PAR DÉFAUT (aucun graph actif)
      ══════════════════════════════════════ */}
      {!showGraph7 && !showGraph8 && !showGraph9 && (
        <>
          <div className="card1" style={{ position: 'absolute', top: '640px', left: '1050px' }}>
            <Card1 />
          </div>
          <div className="card1" style={{ position: 'absolute', top: '640px', left: '820px' }}>
            <Card41 />
          </div>
          <div className="card1" style={{ position: 'absolute', top: '640px', left: '1280px' }}>
            <Card42 />
          </div>
          <div className="card1" style={{ position: 'absolute', top: '640px', left: '460px' }}>
            <Card />
          </div>
          <div className="card1" style={{ position: 'absolute', top: '640px', left: '230px' }}>
            <Card4 />
          </div>
          <div className="card1" style={{ position: 'absolute', top: '640px', left: '0px' }}>
            <Card3 />
          </div>
          <div className="graph5-container">
            <Graph5 width={700} height={400} />
          </div>
          <div className="graph6-container">
            <Graph6 width={700} height={400} />
          </div>
        </>
      )}

      {/* ══════════════════════════════════════
          GRAPH7 — Taux de couverture (Stock projeté)
      ══════════════════════════════════════ */}
      {showGraph7 && tauxData && (
        <>
          <div className="graph7-container">
            <Graph7
              onBarClick={handleBarClick}
              activeKey={filterColumn}
            />
          </div>
          {renderTauxTable()}
        </>
      )}

      {/* ══════════════════════════════════════
          GRAPH8 — Montant échue client (Cash in)
      ══════════════════════════════════════ */}
      {showGraph8 && (
        <>
          <div className="graph8-container">
            <Graph8 />
          </div>

          <div className="table-echue-client">
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  {tableData[0] &&
                    Object.keys(tableData[0]).map((col) => (
                      <th key={col}>{col}</th>
                    ))}
                </tr>
              </thead>
              <tbody>
                {tableData.map((row, index) => (
                  <tr
                    key={index}
                    className={clientSelectionne === row.Client ? 'row-selected' : ''}
                  >
                    {Object.entries(row).map(([col, val], i) => {
                      if (col === 'Client') {
                        return (
                          <td
                            key={i}
                            style={{ cursor: 'pointer', color: '#185FA5', fontWeight: 500 }}
                            onClick={() => handleClientClick(val)}
                          >
                            {val}
                          </td>
                        );
                      }
                      return (
                        <td key={i}>
                          {typeof val === 'number' ? val.toLocaleString('fr-FR') : val}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {renderCommandesClientTable()}
        </>
      )}

      {/* ══════════════════════════════════════
          GRAPH9 — Montant échue fournisseur (Cash out)
      ══════════════════════════════════════ */}
      {showGraph9 && (
        <>
          <div className="graph8-container">
            <Graph9 />
          </div>

          <div className="table-echue-client">
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  {tableData[0] &&
                    Object.keys(tableData[0]).map((col) => (
                      <th key={col}>{col}</th>
                    ))}
                </tr>
              </thead>
              <tbody>
                {tableData.map((row, index) => (
                  <tr key={index}>
                    {Object.entries(row).map(([col, val], i) => {
                      if (col === 'Fournisseur') {
                        return (
                          <td
                            key={i}
                            style={{
                              cursor: 'pointer',
                              color: '#D85A30',
                              fontWeight: 500,
                              backgroundColor:
                                fournisseurSelectionne === val ? '#fdf1ec' : 'transparent',
                            }}
                            onClick={() => handleFournisseurClick(val)}
                          >
                            {val}
                          </td>
                        );
                      }
                      return (
                        <td key={i}>
                          {typeof val === 'number' ? val.toLocaleString('fr-FR') : val}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {fournisseurSelectionne && commandesFournisseur.length > 0 && (
            <div className="detail_cmde_echue" style={{ marginTop: '-365px' }}>
              <table>
                <thead>
                  <tr>
                    {["Numero de commande", "Date d'échéance", 'Montant'].map((col) => (
                      <th key={col}>{col}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {commandesFournisseur.map((row, idx) => (
                    <tr key={idx}>
                      {["Numero de commande", "Date d'échéance", 'Montant'].map((col, i) => (
                        <td key={i}>
                          {typeof row[col] === 'number'
                            ? row[col].toLocaleString('fr-FR')
                            : row[col]}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}

    </div>
  );
};

export default Cashmanagment;